import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            blanks: [],
            activeTab: 'active',
            successGenerate: false,
            lastUrl: null,
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        },
        successTreeGenerate: (state) => {
            return state.successGenerate;
        }
    },
    mutations: {
        setTreeBlanks(state, value) {
            state.blanks = value;
        },
        addBlank(state, value) {
            state.blanks.data.unshift(value);
        },
        removeBlank(state, item) {
            for (let i = 0; i < state.blanks.data.length; i++) {
                if (state.blanks.data[i].id === item.id) {
                    window.Vue.delete(state.blanks.data, i, item);
                }
            }
        },
        updateBlank(state, item) {
            for (let i = 0; i < state.blanks.data.length; i++) {
                if (state.blanks.data[i].id === item.id) {
                    window.Vue.set(state.blanks.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
        setSuccessTreeGenerate(state, value) {
            state.successGenerate = value;
        }
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/tree-blank', payload)
                    .then((response) => {
                        commit('setTreeBlanks', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allBlank({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/tree-blank/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getBlank({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/tree-blank/'+ id)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createTreeBlank({state, commit, getters}, pagesToGenerate){
            return new Promise((resolve, reject) => {
                ApiService.post('/tree-blank', pagesToGenerate)
                    .then((response) => {
                        state.lastUrl = response.data.fileUrl;
                        commit('addBlank',response.data);
                        commit('setSuccessTreeGenerate', true);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
            });
        },
    }
};
